import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/app/providers';
import { axiosInstance } from '@/shared/api/axiosInstance';

// Типы, если нет отдельного файла types.ts
export interface User {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    secondName?: string;
    birthDate?: string;
    insuranceCompany?: string;
}


export interface AuthState {
    token: string | null;
    isAuthenticated: boolean;
    user: User | null;
}

// Инициализация из localStorage
const savedToken = localStorage.getItem('access_token');
const savedUser = localStorage.getItem('user');

const initialState: AuthState = {
    token: savedToken || null,
    isAuthenticated: !!savedToken,
    user: savedUser ? JSON.parse(savedUser) : null,
};

if (savedToken) {
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${savedToken}`;
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loginSuccess(state, action: PayloadAction<{ token: string; user: User }>) {
            state.token = action.payload.token;
            state.user = action.payload.user;
            state.isAuthenticated = true;

            localStorage.setItem('access_token', action.payload.token);
            localStorage.setItem('user', JSON.stringify(action.payload.user));

            axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${action.payload.token}`;
        },
        logout(state) {
            state.token = null;
            state.user = null;
            state.isAuthenticated = false;

            localStorage.removeItem('access_token');
            localStorage.removeItem('user');

            delete axiosInstance.defaults.headers.common['Authorization'];
        },
    },
});

export const { loginSuccess, logout } = authSlice.actions;
export const selectUser = (state: RootState) => state.auth.user;
export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
export default authSlice.reducer;
